export default "__VITE_ASSET__23600751__"